module.exports = __webpack_public_path__ + "static/media/33.6f36ba73.png";